import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-finalize-confirm-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <p-dialog
      header="Ellenőrzés sikeres"
      [visible]="visible"
      (visibleChange)="visibleChange.emit($event)"
      [modal]="true"
      [style]="{ width: '480px' }"
    >
      <div style="display: flex; align-items: center; gap: 0.75rem; padding: 0.5rem 0">
        <i class="pi pi-check-circle" style="font-size: 1.75rem; color: #34a853"></i>
        <p style="margin: 0">
          Minden kötelező melléklet társítva van. Most véglegesítheti az elszámolást.
        </p>
      </div>
      <ng-template pTemplate="footer">
        <p-button label="MÉGSEM" severity="secondary" [text]="true" (onClick)="visibleChange.emit(false)" />
        <p-button label="VÉGLEGESÍTÉS" icon="pi pi-check" iconPos="left" (onClick)="finalize.emit()" />
      </ng-template>
    </p-dialog>
  `,
})
export class FinalizeConfirmDialog {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() finalize = new EventEmitter<void>();
}
